import { HttpClient, HttpMethods } from "@planzone/services";

type CachedData = {
  expiresAt: number;
  data: any;
};

interface Store {
  get(key: string): any | null;
  set(key: string, data: any): void;
}

function hasExpired(expiresAt: number) {
  return new Date(expiresAt) <= new Date();
}

function createStore(): Store {
  const db: { [key: string]: CachedData } = {};

  return {
    get(key) {
      const cachedData = db[key];

      if (!cachedData) {
        return null;
      }

      if (hasExpired(cachedData.expiresAt)) {
        delete db[key];

        return null;
      }

      return cachedData.data;
    },
    set(key, data) {
      db[key] = { expiresAt: new Date().getTime() + 1000 * 30, data };
    },
  };
}

const taskExpr = `/tasks/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$`;

function createCache(httpClient: HttpClient): HttpClient {
  const store = createStore();

  return {
    sendHttpRequest(config): Promise<any> {
      return httpClient.sendHttpRequest(config);
    },
  };
}

export { createCache };
